<template>
	<div
		class="modal delete overlay"
		:class="isShow == true ? 'active' : ''"
		@click.self="modalClose"
	>
		<div class="modal_window">
			<div class="modal_window_head">
				<div class="modal_window_head_title">
					<i class="fas fa-solid fa-trash fa-fw text-color-white2" />
					{{ title }}
					<button type="button" class="circleBtn" @click="modalClose">
						<i class="fa-solid fa-circle-xmark fa-fw" />
					</button>
				</div>
			</div>
			<div class="modal_window_content">
				<slot name="contents"></slot>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'submit'"
						:button-class="'button-red'"
						:button-icon="'fa-trash'"
						:button-text="'削除する'"
						@click="dataDelete"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import { ref, computed, defineProps, defineEmits } from "vue";
// utils
import scrollControlFunction from "@/utils/ScrollControl.js";
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { parentScrollUnlock } = scrollControlFunction();
/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["modalClose", "dataDelete"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	isModal: Boolean,
	title: String
});
/* ---------------------------------------------------------------------------
	computed
---------------------------------------------------------------------------- */
const isShow = computed({
	get: () => props.isModal,
	set: value => emit("modalClose", value)
});
/* ---------------------------------------------------------------------------
	削除実行
---------------------------------------------------------------------------- */
function dataDelete() {
	emit("dataDelete");
	modalClose();
	// 親要素のscroll非表示解除
	parentScrollUnlock();
}
/* ---------------------------------------------------------------------------
	モーダル
---------------------------------------------------------------------------- */
// モーダルを閉じる
function modalClose() {
	isShow.value = false;
	// 親要素のscroll非表示解除
	parentScrollUnlock();
}
</script>
